import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/PricingPage.css';

function PricingPage() {
  const navigate = useNavigate();

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: 'smooth' });
  }, []);

  const handleSelectPlan = (planKey) => {
    navigate(`/register/physiotherapist?membership=${planKey}`, {
      state: { membership: planKey, billingCycle: 'monthly' },
    });
  };

  return (
    <div className="pm-pricing-page">
      {/* Dynamic Background Glows */}
      <div className="pm-pricing-ambient-mesh">
        <div className="pm-pricing-orb pm-pricing-orb-1"></div>
        <div className="pm-pricing-orb pm-pricing-orb-2"></div>
      </div>

      {/* =========================================================
          COMPACT & MINIMAL HERO SECTION
          ========================================================= */}
      <header className="pm-pricing-hero">
        <div className="pm-pricing-hero-inner">
          <h1 className="pm-pricing-main-title">
            <span className="pm-pricing-gradient">Pricing</span>
          </h1>

          <p className="pm-pricing-subtitle">
            Keep 100% of your earnings. Select the monthly plan that fits your clinical practice.
          </p>
        </div>
      </header>

      {/* =========================================================
          PRICING PLAN CARDS (2-Column Modern Grid)
          ========================================================= */}
      <section className="pm-pricing-cards-section">
        <div className="pm-pricing-cards-grid">
          {/* FREE PLAN */}
          <div className="pm-plan-card is-free">
            <div>
              <div className="pm-plan-header">
                <div className="pm-plan-icon-wrap">🌱</div>
                <h2 className="pm-plan-title">Free Listing</h2>
                <p className="pm-plan-tagline">Basic Practitioner Profile</p>

                <div className="pm-plan-price-wrap">
                  <div className="pm-plan-price">₹0</div>
                  <div className="pm-plan-duration">/ forever free</div>
                </div>
              </div>

              <ul className="pm-plan-features-list">
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Two-Way Calendar Sync:</strong> Google Calendar</span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Auto Google Meet:</strong> Telehealth video links</span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Digital Products Sales:</strong> 100% Payouts</span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon" style={{ background: '#fef3c7', color: '#b45309' }}>
                    <i className="fas fa-exclamation"></i>
                  </span>
                  <span>Standard search ranking &amp; 1 photo limit</span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              className="pm-plan-btn"
              onClick={() => handleSelectPlan('free')}
            >
              <span>Start Free Listing</span>
              <i className="fas fa-arrow-right"></i>
            </button>
          </div>

          {/* PRO PLAN (FEATURED) */}
          <div className="pm-plan-card is-pro">
            <span className="pm-pro-badge-top">
              <i className="fas fa-sparkles me-1"></i> RECOMMENDED FOR PRACTITIONERS
            </span>

            <div>
              <div className="pm-plan-header">
                <div className="pm-plan-icon-wrap">💎</div>
                <h2 className="pm-plan-title">Pro Provider</h2>
                <p className="pm-plan-tagline" style={{ color: '#7c3aed', fontWeight: 700 }}>
                  All-in-One Clinical Suite
                </p>

                <div className="pm-plan-price-wrap">
                  <div className="pm-plan-price">₹999</div>
                  <div className="pm-plan-duration">
                    /month
                    <span className="pm-plan-annual-sub" style={{ color: '#6b7280' }}>
                      Billed monthly • Cancel anytime
                    </span>
                  </div>
                </div>
              </div>

              <ul className="pm-plan-features-list">
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Pro Verified VIP Badge</strong> &amp; Priority Search Ranking</span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Automatic WhatsApp &amp; Email Reminders</strong> (Slash No-Shows)</span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>Clinical Notes Templates</strong> (SOAP) &amp; Worksheets Library</span>
                </li>
                <li className="pm-plan-feature-item">
                  <span className="pm-plan-check-icon"><i className="fas fa-check"></i></span>
                  <span><strong>1 Free Workshop / Month</strong> &amp; Multi-Session Packages</span>
                </li>
              </ul>
            </div>

            <button
              type="button"
              className="pm-plan-btn"
              onClick={() => handleSelectPlan('pro')}
            >
              <span>Get Started with Pro</span>
              <i className="fas fa-arrow-right"></i>
            </button>
          </div>
        </div>
      </section>
    </div>
  );
}

export default PricingPage;
